import {
  AfterViewInit,
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalizationService } from 'src/app/services/localization/localization.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements AfterViewInit {
  userLang = '';
  accessToken = localStorage.getItem('accessToken');
  constructor(
    private router: Router,
    private localizationService: LocalizationService
  ) {
    this.userLang =
      this.localizationService.getUserLang() === 'ar' ? 'en' : 'ar';
  }
  @ViewChild('menu_icon') menu!: ElementRef;
  @ViewChild('close_icon') close!: ElementRef;
  @ViewChild('header') header!: ElementRef;
  @ViewChildren('tab_item') tabItem!: QueryList<ElementRef>;

  ngAfterViewInit() {
    this.tabItem.forEach((link: any) => {
      link.nativeElement.addEventListener('click', () => {
        this.tabItem.forEach((tab) => {});
        this.header.nativeElement.classList.add('d-none');
      });
    });
    this.menu.nativeElement.addEventListener('click', () => {
      this.header.nativeElement.classList.remove('d-none');
    });
    this.close.nativeElement.addEventListener('click', () => {
      this.header.nativeElement.classList.add('d-none');
    });
  }

  changeLang() {
    this.localizationService.setUserLang(this.userLang);

    this.userLang =
      this.localizationService.getUserLang() === 'ar' ? 'en' : 'ar';
    this.header.nativeElement.classList.add('d-none');
  }

  logout() {
    localStorage.clear();
if (typeof window !== 'undefined') {
    window.location.href = '/';
}
  }
}
